import { asiakas_hasLaskutus } from "../asiakas/asiakasSettingsClass";

export function allowAccess_KalleUrhoOy_Toiminnot(user) {
  try {
    if (!user.settings.isPumppuAdmin) return false;
    if (!user.asiakasListContains(8)) return false; // person has Kalle Urho Oy
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export function allowAccess_tyomaaPersons(user, tyomaa, keikkaData = null) {
  try {
    if (tyomaa.auth && tyomaa.auth.listPersons) return true;
    if (user.isAnyAdmin) return true;
    if (keikkaData && keikkaData.auth.isKeikkaAdmin) return true;
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
}
export function allowAccess_lasku_by_keikkaData(user, keikkaData, laskuttajaType = "pumppu") {
  const _laskuttajaAsiakas = keikkaData.laskutus.getLaskuttajaAsiakas(keikkaData, laskuttajaType);
  const _maksajaAsiakas = keikkaData.laskutus.getMaksajaAsiakas(keikkaData, laskuttajaType);
  return allowAccess_lasku(user, _maksajaAsiakas, _laskuttajaAsiakas);
}
export function allowAccess_lasku(user, maksajaAsiakas, laskuttajaAsiakas) {
  try {
    if (!user) return false;
    if (laskuttajaAsiakas) {
      const saaNähdäLaskun = laskuttajaAsiakas.auth.getAsiakasPersonSetting([5, 7]);
      if (saaNähdäLaskun && asiakas_hasLaskutus(laskuttajaAsiakas)) return true;
    }
    if (maksajaAsiakas) {
      const saaNähdäLaskun = maksajaAsiakas.auth.getAsiakasPersonSetting([5, 7]);
      if (saaNähdäLaskun && asiakas_hasLaskutus(maksajaAsiakas)) return true;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
}
